var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-12",class:_vm.brakingPoints},[_c('div',{staticClass:"card border-radius-8 shadow mb-5"},[_c('div',{staticClass:"card-body",class:_vm.card_padding},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }